import { LogoutPage } from '@app/core/auth/flow';
import { App } from '@app/core/containers/App';
import { Route, Switch } from 'react-router-dom';

export function AppRootRoutes() {
  return (
    <Switch>
      <Route path="/logout" component={LogoutPage} />
      <App />
    </Switch>
  );
}
